import {Input, InputGroup} from "rsuite";
import React from "react";

const MechanismMeteoDataSection = ({ meteoData, isMechanismMovement, isConnected = true }) => {
  return (
    <>
      <div style={{
        opacity: !isConnected ? 0.6 : (isMechanismMovement() ? 0.5 : 1),
        pointerEvents: !isConnected ? 'none' : undefined
      }}>
        <p className="mb-2 mt-2">МЕТЕОДАННЫЕ</p>
        <div className="row mb-1">
          <div className="col-md-3 mt-1">
            <InputGroup>
              <InputGroup.Addon>Температура</InputGroup.Addon>
              <Input
                readOnly={true}
                size={"md"}
                value={meteoData?.temperature}
              />
            </InputGroup>
          </div>
          <div className="col-md-3 mt-1">
            <InputGroup>
              <InputGroup.Addon>Давление</InputGroup.Addon>
              <Input
                readOnly={true}
                size={"md"}
                value={meteoData?.pressure}
              />
            </InputGroup>
          </div>
          <div className="col-md-3 mt-1">
            <InputGroup>
              <InputGroup.Addon>Влажность</InputGroup.Addon>
              <Input
                readOnly={true}
                size={"md"}
                value={meteoData?.humidity}
              />
            </InputGroup>
          </div>
        </div>
      </div>

    </>
  )
}

export default MechanismMeteoDataSection
